export const DRAFT_SUBMIT = "DRAFT_SUBMIT";
export const getDraftSubmit = (data) => {
    return {
        type: DRAFT_SUBMIT,
        payload: data
    }
}